/**
 * AI.GEN lines=1-30
 * 配送骑手相关接口
 */
import type {
  AssignedDriverRequest,
  AssignedDriverResponse,
  GpsInfoItem,
  GpsInfoRequest,
} from './declare';
import { context } from '@/context';
import { Request } from '@/context/request';

const request: Request = context.request;
const host = '';

/**
 * 获取配送中订单的背单骑手
 * @param params 请求参数
 * @param params.orderSn 订单号（必填）
 * @returns 背单骑手信息响应
 */
export const apiDeliveryDriverAssignedDriver = async (
  params: AssignedDriverRequest,
): Promise<AssignedDriverResponse> => {
  return request.post(
    host + '/api/dispatch/deliveryDriver/assignedDriver',
    params,
  );
};

/**
 * AI.GEN lines=1-10
 * 获取骑手GPS信息
 * @param params 请求参数
 * @param params.driverIdList 骑手ID列表（可选）
 * @returns 骑手GPS信息响应
 */
export const apiDeliveryDriverGpsInfo = async (
  params: GpsInfoRequest,
): Promise<GpsInfoItem[]> => {
  return request.post(host + '/api/dispatch/deliveryDriver/gpsInfo', params, {
    disableErrorMsg: true,
  } as any);
};
